var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoJ(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b86d0e1c-42ad-4a5d-9a83-b6525c9ab205{fill:#e16590;}.ec705e8b-f561-43ef-b557-9aff2f78cdbb{fill:#f1a0c3;}.baef0767-44eb-461e-aa8e-78a64c7a6360{fill:#00756c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8D44\u6E90 37") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ea8a0512-08ee-4aed-975a-0cc23350eea1",
    "data-name": "\\u56FE\\u5C42 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bdcf6f13-6638-4e29-b7a2-ce3547617f67",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b86d0e1c-42ad-4a5d-9a83-b6525c9ab205",
    d: "M45,0H30V20H50V5A5,5,0,0,0,45,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ec705e8b-f561-43ef-b557-9aff2f78cdbb",
    d: "M20,0a10,10,0,0,0,0,20H30V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ec705e8b-f561-43ef-b557-9aff2f78cdbb",
    d: "M30,30a10,10,0,0,0,20,0V20H30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "baef0767-44eb-461e-aa8e-78a64c7a6360",
    d: "M40,44.94a10,10,0,0,0-10,10V80H10a10,10,0,0,0,0,20H40A10,10,0,0,0,50,90V54.94A10,10,0,0,0,40,44.94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJ);
export default __webpack_public_path__ + "static/media/logo-j.c38925a368e56dde2047c628c886898d.svg";
export { ForwardRef as ReactComponent };